import { Typography } from 'antd';
import DatePickerr from './DatePickerr';
import DropdownState from './DropdownState';
import DropdownFilter from './DropdownFilter';
import SearchInput from './SearchInput';

interface Dropdown {
  title: string;
  value: string;
}

interface Props {
  handleDateValue: Function;
  handleStateValue: Function;

  handleInputValue: Function;
}

function FilterAction({
  handleDateValue,
  handleStateValue,
  handleInputValue
}: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        marginBottom: '21px'
      }}
      className="busk-filter-action"
    >
      <DatePickerr handleDateValue={handleDateValue} />

      <DropdownState
        filterBy={[
          { title: '선택', value: '' },
          { title: '업체명', value: 'name' },
          { title: '아이디', value: 'id' },
          { title: '국가', value: 'country' }
        ]}
        handleStateValue={handleStateValue}
      />

      <SearchInput handleInputValue={handleInputValue} />
    </div>
  );
}

export default FilterAction;
